import { Action } from '@ngrx/store';

export class GlobalsAction implements Action {

    public static attachLiveVideo = '[Globals] attach_live_video';

    public static dettachLiveVideo = '[Globals] dettach_live_video';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
